import type { JSX } from 'react';

import { cx } from '@emotion/css';

import { MTypography } from '../lib/MTypography/MTypography';
import { Font, Spacing } from '../styles';

export const renderTradingBlockSamePasswordErrorMessage = ({ onClick }: { onClick: () => void }): JSX.Element => {
  return (
    <MTypography variant='body1'>
      Your last password change was not accepted because it was a previously used password. Please click
      <a className={cx(Spacing.p4, Font.lg)} onClick={onClick}>
        here
      </a>{' '}
      to reset your password again and use a different password that you HAVE NOT used before.
    </MTypography>
  );
};
